module.exports = __webpack_public_path__ + "static/tracking_code_tab-a69df06ee7d179b611cb578fc6abd326.png";